module.exports = __webpack_public_path__ + "static/media/Cial_D&B_Logo-White.39a45979.svg";